export class Environment {
  static get apiPaymentsURL(): string {
    return process.env.NEXT_PUBLIC_SST_API_PAYMENTS || "/merchants/pay";
  }

  static get apiPaymentsLinksURL(): string {
    return process.env.NEXT_PUBLIC_SST_API_EXTERNAL_PAYMENTS_LINKS || "external_payments/payments_links/";
  }
}
